import { createSlice } from '@reduxjs/toolkit'

import { getAvatars } from '../lib/api'
import { chunkArray } from '../utilities'
import { AddErrorAlert } from './alert'

const MAX_REQUEST_SIZE = 50
const DELAY = 2500

export const avatarSlice = createSlice({
  name: 'avatar',
  initialState: {
    loading: [],
    timer: null,
    cache: {},
    error: null
  },

  reducers: {
    loading: (state, { payload }) => {
      const { id, timer } = payload

      state.loading.push(id)
      clearTimeout(state.timer)
      state.timer = timer
    },

    loadComplete: (state, { payload }) => {
      payload.forEach(({ id, data }) => {
        state.cache[id] = data
      })

      state.loading = []
    },

    clear: (state, { payload }) => {
      delete state.cache[payload]
    },

    failed: (state, { payload }) => {
      state.error = payload
    }
  }
})

export const { loading, loadComplete, clear, failed } = avatarSlice.actions

// Asynchronous thunk action

export function fetchAvatar (id) {
  return async (dispatch, getState) => {
    if (!id) {
      return
    }

    const { loading: storedIDs, cache } = selectAvatar(getState())

    if (id in cache || storedIDs.includes(id)) {
      return
    }

    const timer = setTimeout(async () => {
      try {
        const ids = selectAvatar(getState()).loading
        const chunks = chunkArray(ids, MAX_REQUEST_SIZE)

        const avatarResults = await Promise.all(
          chunks.map(async chunk => {
            if (chunk.length) {
              try {
                return await getAvatars(chunk)
              } catch (err) {
                console.error('Error loading avatars', err)
              }
            }
            return []
          })
        )

        dispatch(loadComplete(avatarResults.flat()))
      } catch (err) {
        dispatch(AddErrorAlert(err))
        dispatch(failed(err))
      }
    }, DELAY)

    dispatch(loading({ id, timer }))
  }
}

export const selectAvatar = state => state.avatar

export default avatarSlice.reducer
